import { RequestDashboardTable, RequestDashboardTableConfig } from '../scripts/request-dashboard.table';

export class MyRequestsPage {
    newFormButton: JQuery<HTMLElement>;
    loadingFormModal: JQuery<HTMLElement>;

    requestTable: RequestDashboardTable;
    tableConfig: RequestDashboardTableConfig;

    constructor() {
        $(() => {
            this.tableConfig = {
                tableContainerId: "my-requests-content",
                getRoute: "/secure/biospecimens/sample-request-form/request-dashboard/request-dashboard?handler=Applications",
                loadingContainerId: "loading-content-container",
                loadedContentId: "loaded-my-requests-content",
                isEditable: true,
                isReviewer: false,
                tableVarName: "requestTable"
            }
            this.requestTable = new RequestDashboardTable(this.tableConfig);
            this.newFormButton = $("#new-form-btn");
            this.loadingFormModal = $("#loading-form-modal");

            this.initializeNewFormButton();
        });
    }
    initializeNewFormButton() {
        this.newFormButton.on("click", () => {
            this.loadingFormModal.modal('show');
        })
    }

    initializePrintBtn() {

    }
}